import { Fetch } from '@nio-pow/mfe-vue3'
import envConfig from './envConfig'

const { APP_ID, BASE_API } = envConfig
const { version } = require('../../package.json')

export const fetchBackend = Fetch.genFetch(BASE_API, {
  needAuth: true,
  commonParams: { appId: APP_ID, appVer: version },
})
